import React from "react";
import ChoixParchemin from "../../components/room5/ChoixParchemin";


function RoomParchemin() {
        return (
            <ChoixParchemin/>
        );
}
export default RoomParchemin;